import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { If } from 'src/Components/Conditionals'
import Format from 'src/Components/Format'
import Text from 'src/Components/Text'
import List from 'src/Components/List'
import PrequalAvatar from 'src/features/buyers/Components/Global/AffordabilityModal/PrequalTab/PrequalAvatar'
import LoanTerm from 'src/features/buyers/Components/Global/AffordabilityModal/PrequalTab/LoanTerm'

import styles from './Prequal.module.scss'

const propTypes = {
  className: PropTypes.string
}

const Prequal = ({
  adjustable,
  amount,
  armYearsInitial,
  className,
  expirationDate,
  fromDate,
  loanOfficerAvatarUri,
  loanType,
  payment,
  rate
}) => (
  <div data-qa='Prequal' className={classnames(styles.root, className)}>
    <PrequalAvatar
      className={classnames(styles.avatar)}
      src={loanOfficerAvatarUri}
    />

    <div className={styles.details}>
      <If condition={fromDate}>
        <Text paragraph>
          <FormattedMessage
            id='Affordability.prequalDetail.heading'
            defaultMessage='Pre-Qual from {date}:'
            values={{
              date: fromDate.format('MMMM YYYY')
            }}
          />
        </Text>
      </If>

      <If condition={payment}>
        <Text size='xs' color='quiet'>
          <FormattedMessage
            id='Affordability.prequalDetail.payment'
            defaultMessage='{payment}/mo (principal & interest)'
            values={{
              payment: <Format.Currency value={payment} format='0,0' />
            }}
          />
          <If condition={adjustable && armYearsInitial}>
            {' '}
            <FormattedMessage
              id='Affordability.prequalDetail.adjustable'
              defaultMessage='for first {years} years'
              values={{ years: armYearsInitial }}
            />
          </If>
        </Text>
      </If>

      <List.Bulleted.Inline className={styles.terms} itemClass={styles.term}>
        <Text element='span' size='xs' color='quiet'>
          {loanType}
        </Text>
        <Text element='span' size='xs' color='quiet'>
          <LoanTerm />
        </Text>
        <Text element='span' size='xs' color='quiet'>
          <Format.Rate value={rate} />
        </Text>
      </List.Bulleted.Inline>

      <If condition={expirationDate}>
        <Text size='xs' color='quiet'>
          <FormattedMessage
            id='Affordability.prequalDetail.expiration'
            defaultMessage='Expires {date}'
            values={{
              date: expirationDate
            }}
          />
        </Text>
      </If>
    </div>

    <Text className={styles.amount} color='green' size='xl'>
      <Format.Currency abbreviate value={amount} />
    </Text>
  </div>
)

Prequal.propTypes = propTypes

export default Prequal
